// Copyright (c) 2017 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import LeadAccountPanelCollection from './lead-account-panel-collection';
import ReimbursementSummaryDropdown from './reimbursement-summary-dropdown';
import ReimbursementSummaryLeadAccount from '@deere/cps-it.warranty-model-factory/lib/reimbursement-summary-lead-account';

class ReimbursementSummaryAside extends Component {

    componentWillMount = () => {

        if (this.props.isInitialLoad) {

            this.props.actions.readReimbursementSummary(this.props.selectedPostingDate);

        }

    };

    componentWillReceiveProps = nextProps => {

        if (this.props.selectedPostingDate !== nextProps.selectedPostingDate) {

            this.props.actions.readReimbursementSummary({
                ...nextProps.selectedPostingDate
            });

        }

    };

    handleLeadAccountChange = newSelectedLeadAccount => {

        this.props.actions.updateSelectedLeadAccount(newSelectedLeadAccount);

    };

    handlePostingDateChange = newPostingDate => {

        this.props.actions.updateSelectedPostingDate(newPostingDate);

        if (this.props.pathName !== '/') {

            this.props.actions.updateViewAllDateRange(newPostingDate, this.props.pathName, this.props.queryParams);

        }

    };

    handleSelectedValueChange = selectedValue => {

        this.props.actions.updateSelectedValue(selectedValue);

    };

    render = () =>
        <aside className='reimbursement-summary-aside'>
            <ReimbursementSummaryDropdown
                leadAccounts={this.props.leadAccounts}
                onPostingDateChange={this.handlePostingDateChange}
                onSelectedValueChange={this.handleSelectedValueChange}
                selectedPostingDate={this.props.selectedPostingDate}
                selectedValue={this.props.selectedValue}
            />
            <LeadAccountPanelCollection
                leadAccounts={this.props.leadAccounts}
                onLeadAccountChange={this.handleLeadAccountChange}
                selectedLeadAccount={this.props.selectedLeadAccount}
            />
        </aside>;

}

ReimbursementSummaryAside.displayName = 'ReimbursementSummaryAside';
ReimbursementSummaryAside.propTypes = {
    actions: PropTypes.object.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    leadAccounts: PropTypes.arrayOf(PropTypes.instanceOf(ReimbursementSummaryLeadAccount)).isRequired,
    pathName: PropTypes.string.isRequired,
    queryParams: PropTypes.object.isRequired,
    selectedLeadAccount: PropTypes.string.isRequired,
    selectedPostingDate: PropTypes.object,
    selectedValue: PropTypes.string.isRequired
};

ReimbursementSummaryAside.defaultProps = {
    pathName: '/',
    queryParams: {}
};

export default ReimbursementSummaryAside;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/reimbursement-summary-aside/reimbursement-summary-aside.js